import { HttpParams } from '@angular/common/http';

export class QueryFilter {
    text: string;
    page: number;
    pageSize: number;
    sortDirection: string;
    totalCount: number;
    pageMaximum: number;
    pageMinimum: number;
    sortColumn: string;
    sortByRank: boolean;

    constructor() {
        this.text = '';
        this.page = 1;
        this.pageSize = 10;
        this.sortDirection = 'ASC';
        this.sortColumn = null;
        this.totalCount = 0;
        this.pageMaximum = 50;
        this.pageMinimum = 1;
        this.sortByRank = false;
    }

    reset(): void {
        for (const key in this) {
            if (this[key] && typeof this[key] !== 'function' && key !== 'totalCount') {
                this[key] = null;
            }
        }
        this.text = '';
        this.page = 1;
        this.pageSize = 10;
        this.sortDirection = 'ASC';
        this.pageMaximum = 50;
        this.pageMinimum = 0;
    }

    toHttpParams(): HttpParams {
        let httpParams = new HttpParams();
        for (const key in this) {
            if (this[key] && typeof this[key] !== 'function') {
                if (this[key] instanceof Date) {
                    httpParams = this.setParam(httpParams, key, (this[key]).toString());
                } else {
                    httpParams = this.setParam(httpParams, key, this[key].toString());
                }
            }
        }
        return httpParams;
    }

    private setParam(httpParams: HttpParams, param: string, value?: any): HttpParams {
        if (value !== undefined && value !== null) {
            return httpParams.set(param, value);
        }
        return httpParams;
    }
}
